import SoldPropertiesList from './containers/SoldPropertiesListPageContainer'

export default SoldPropertiesList
